export const FREIGHT_EMAIL_ID = "freight@deliverr.com";
